export const typography = {
  lineHeights: {
    normal: 'normal',
    none: '1em',
    shorter: '1.1em',
    short: '1.25em',
    base: '1.35em',
    tall: '1.45em',
    taller: '2em',
  },
  fonts: {
    body: 'var(--nabis-font-family)',
    heading: 'var(--nabis-font-family)',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace',
  },
  fontSizes: {
    xs: '0.25rem',
    sm: '0.8rem',
    md: '0.9rem',
    lg: '1.25rem',
    xl: '1.5rem',
    '2xl': '1.75rem',
    '3xl': '2rem',
    '4xl': '3rem',
  },
  textStyles: {
    pageTitle: {
      fontSize: '1.75rem',
      fontWeight: '600',
      lineHeight: '1.35em',
    },
    containerTitle: {
      fontSize: '1.25rem',
      fontWeight: '600',
      lineHeight: '1.35em',
    },
    sectionHeading: {
      fontSize: '1rem',
      fontWeight: '600',
      lineHeight: '1.35em',
    },
    sectionHeadingCaps: {
      fontSize: '1rem',
      fontWeight: '600',
      lineHeight: '1.35em',
      textTransform: 'uppercase',
    },
    displaySmall: {
      fontSize: '1rem',
      fontWeight: '400',
      lineHeight: '1.35em',
    },
    displayMedium: {
      fontSize: '1.25rem',
      fontWeight: '400',
      lineHeight: '1.35em',
    },
    displayLarge: {
      fontSize: '1.5rem',
      fontWeight: '400',
      lineHeight: '1.35em',
    },
    badge: {
      fontSize: '0.625rem',
      fontWeight: '600',
      lineHeight: '1em',
      textTransform: 'none',
    },
    body: {
      fontSize: '0.875rem',
      fontWeight: '400',
      lineHeight: '1.35em',
    },
    bodyMedium: {
      fontSize: '0.875rem',
      fontWeight: '500',
      lineHeight: '1.35em',
    },
    bodyStrong: {
      fontSize: '0.875rem',
      fontWeight: '600',
      lineHeight: '1.35em',
    },
    caption: {
      fontSize: '0.75rem',
      fontWeight: '400',
      lineHeight: '1.35em',
    },
    captionMedium: {
      fontSize: '0.75rem',
      fontWeight: '500',
      lineHeight: '1.35em',
    },
    captionStrong: {
      fontSize: '0.75rem',
      fontWeight: '600',
      lineHeight: '1.35em',
    },
    menuGroupTitle: {
      fontSize: '0.75rem',
      fontWeight: '600',
      lineHeight: '1.35em',
    },
    textWrapMobileButton: {
      fontSize: '.875rem',
      whiteSpace: ['normal', 'nowrap'],
      height: ['auto', 'default'],
    },
  },
} as const;
